import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '../../../../../../components';
import { constants as imagesConstants } from '../../../../../../redux/images';

const { INSTRUCTION_TYPE, INSTRUCTION_TYPE_NAMES } = imagesConstants;

const InstructionModal = ({ show, onClose, onSave, selectedInstructions, vehicleType, triggerRef }) => {
  const [tempInstructions, setTempInstructions] = useState(selectedInstructions);

  const availableInstructions = vehicleType === 1 // CAR
    ? [
      INSTRUCTION_TYPE.FIRST_WINDSHIELD,
      INSTRUCTION_TYPE.DOOR_JAMB,
      INSTRUCTION_TYPE.UNDER_DRIVER_SEAT,
      INSTRUCTION_TYPE.PASSENGER_DOOR_AND_SEAT,
      INSTRUCTION_TYPE.ENGINE_ROOM,
      INSTRUCTION_TYPE.PASSENGER_SIDE
    ]
    : vehicleType === 3 // TRUCK
      ? [INSTRUCTION_TYPE.FIRST_WINDSHIELD, INSTRUCTION_TYPE.SECOND_WINDSHIELD]
      : [];

  const handleToggle = (instructionType) => {
    if (tempInstructions.includes(instructionType)) {
      setTempInstructions(tempInstructions.filter((i) => i !== instructionType));
    } else {
      setTempInstructions([...tempInstructions, instructionType].sort((a, b) => a - b));
    }
  };

  const handleSave = () => {
    onSave(tempInstructions);
    onClose();
  };

  return (
    <Popover show={show} onClose={onClose} triggerRef={triggerRef} width={250} height={300}>
      <div className="popover-content">
        {availableInstructions.map((instructionType) => (
          <div key={instructionType} className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id={`instruction-${instructionType}`}
              checked={tempInstructions.includes(instructionType)}
              onChange={() => handleToggle(instructionType)}
            />
            <label
              className="form-check-label"
              htmlFor={`instruction-${instructionType}`}
            >
              {INSTRUCTION_TYPE_NAMES[instructionType]}
            </label>
          </div>
        ))}
        <div className="mt-3 text-right">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </Popover>
  );
};

InstructionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedInstructions: PropTypes.array.isRequired,
  vehicleType: PropTypes.number.isRequired,
  triggerRef: PropTypes.object
};

export default InstructionModal;
